import { AbstractControl } from '@angular/forms';

export class ConfirmEmailValidator {
	static MatchEmail(control: AbstractControl) {
		const email = control.get('email').value;

		const confirmEmail = control.get('confirmEmail').value;

		if (email !== confirmEmail) {
			control.get('confirmEmail').setErrors({ConfirmEmail: true});
		} else {
			return null;
		}
	}
}
